// Finding an address on the map (Pat, Oct 8 2026: "485 S. Rock Blvd, ALV Building, Reno, NV (Reno-Tahoe
// International Airport)" — a good address, no pin). The free map lookup (OpenStreetMap) gives up on
// anything it doesn't know — a building name, a suite, a place in brackets, "S." with a full stop — so
// the search tries the address as typed, then simpler versions of it, until one lands.
// The same rules live in server/api.js (placeQueries) for the job-location and bid lookups.
const JUNK = /\b(bldg|building|suite|ste|unit|apt|floor|fl|room|rm|hangar|gate|door|dock|attn|c\/o)\b|#/i;

export function placeQueries(text) {
  const raw = String(text || '').trim();
  if (!raw) return [];
  const paren = (raw.match(/\(([^)]+)\)/) || [])[1];
  const noParen = raw.replace(/\([^)]*\)/g, ' ').replace(/\s+/g, ' ').replace(/\s*,\s*(,\s*)+/g, ', ').trim().replace(/,\s*$/, '');
  const fixDots = s => s.replace(/\b([NSEW])\.(?=\s)/gi, '$1');
  const parts = noParen.split(',').map(s => s.trim()).filter(Boolean).filter(p => !/^(usa|us|united states( of america)?)$/i.test(p));
  const kept = parts.filter((p, i) => i === 0 || !JUNK.test(p));
  const street = parts.find(p => /^\d+\s+\S/.test(p));
  const town = kept.filter(p => p !== street);
  const townNoZip = town.map(p => p.replace(/\s*\b\d{5}(-\d{4})?\b/, '').trim()).filter(Boolean);
  const out = [
    raw,
    noParen,
    fixDots(kept.join(', ')),
    street ? fixDots([street, ...town.slice(-2)].join(', ')) : null,
    street ? fixDots([street, ...townNoZip.slice(-2)].join(', ')) : null,
    paren ? [paren, ...townNoZip.slice(-2)].join(', ') : null,
  ];
  return [...new Set(out.filter(Boolean).map(s => s.trim()))];
}

const pause = ms => new Promise(r => setTimeout(r, ms));
// Of a few answers, the exact house / building over the street as a whole (the service gives either).
export const bestPlace = list => (list || []).find(d => d.type === 'house' || d.class === 'building' || d.addresstype === 'building') || (list || [])[0] || null;

// → { lat, lng, display, query, exact } or null. exact = it matched what was typed.
export async function findPlace(text) {
  const tries = placeQueries(text);
  for (let i = 0; i < tries.length; i++) {
    if (i) await pause(1050);   // the lookup's fair-use rule: one a second
    try {
      const r = await fetch(`https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(tries[i])}&format=json&limit=4&countrycodes=us`);
      const d = bestPlace(await r.json());
      if (d) return { lat: parseFloat(d.lat), lng: parseFloat(d.lon), display: d.display_name, query: tries[i], exact: i === 0 };
    } catch { /* try the next one */ }
  }
  return null;
}
